import solarLunar from 'solarlunar'

window.app = {
	// 工具
	tool: {
		// ua
		UA: window.navigator.userAgent.toLowerCase(),
		// 默认浏览器scrollTop
		scrollTop: 0,
		// setTimeout
		time: null,
		// 设置弹窗底层定位
		setPopup: () => {
			app.tool.scrollTop = $(document).scrollTop()
			$("body").css({'position': 'fixed', 'top': -app.tool.scrollTop})
		},
		// 撤销设置弹窗底层定位
		unsetPopup: () => {
			$("body").css({'position': 'static'});
			$(document).scrollTop(app.tool.scrollTop);
		},
		// 加载中
		loading: (msg) => {
			$('body').append(`<div id="bodyLoading" class="body-loading"><span>${msg}</span></div>`);
		},
		// 关闭加载中
		closeLoading: () => {
			if($('#bodyLoading').length) $('#bodyLoading').remove()
		},
		// 提示语
		msg: (msg, duration = 2000) => {
			clearTimeout(app.tool.time)
			if($('#bodyMsg').length) $('#bodyMsg').remove()
			$('body').append(`<div id="bodyMsg" class="body-msg">${msg}</div>`);
			if(duration>0){
				app.tool.time = setTimeout(() => {
					if($('#bodyMsg').length) $('#bodyMsg').remove()
				}, duration)
			}
		},
		// 关闭提示语
		closeMsg: () => {
			clearTimeout(app.tool.time)
			if($('#bodyMsg').length) $('#bodyMsg').remove()
		},
		// 判断页面是否滚动到底部
		touchBottom: (distance) => {
			distance = distance || 0
			//文档高度
			let documentHeight = document.documentElement.scrollHeight || document.body.scrollHeight
			// 视口高度
			let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
			// 页面滚动的高度
			let bodyScrollTop = document.documentElement.scrollTop || document.body.scrollTop
			return bodyScrollTop >= documentHeight - windowHeight - distance
		},
		// 格式化时间
		formatTime: (timestamp, format) => {
			const date = new Date(timestamp)
			if (!timestamp || !date || date === 'Invalid Date') {
				console.warn('格式化时间戳：参数错误')
				return ''
			}
			// 默认格式
			format = (format && format.length > 0) ? format : 'Y-M-D H:I:S'
			let Y = date.getFullYear()
			let m = date.getMonth() + 1
			let d = date.getDate()
			let h = date.getHours()
			let i = date.getMinutes()
			let s = date.getSeconds()
			let w = date.getDay()
			let weekCnArr = ['天', '一', '二', '三', '四', '五', '六']
			let json = {
				Y: Y, // 4位年份
				m: m, // 月份没有前导零
				d: d, // 日期没有前导零
				h: h, // 时辰没有前导零
				i: i, // 分钟没有前导零
				s: s, // 秒没有前导零
				w: w, // 周
				W: weekCnArr[w], // 周(中文)
				y: Y.toString().substr(2, 2), // 2位年份
				M: m < 10 ? ('0' + m) : m, // 月份有前导零
				D: d < 10 ? ('0' + d) : d, // 日期有前导零
				H: h < 10 ? ('0' + h) : h, // 时辰有前导零
				I: i < 10 ? ('0' + i) : i, // 分钟有前导零
				S: s < 10 ? ('0' + s) : s // 秒没有前导零
			}
			// 整合字符串
			let resultStr = format
			for (let x in json) {
				let reg = new RegExp(x, 'g')
				resultStr = resultStr.replace(reg, json[x])
			}
			return resultStr
		},
		// 表单验证
		// const rules = [
		// 	{name: 'username', text: '姓名', rule: 'require|chs:2,5', value},
		// ];
		//  必填 rule: 'require'
		// 	中文 2-5字 rule: 'chs:2,5'
		// 	只能是 1或0 rule: 'in:1,0'
		// 	邮箱', rule: 'email'
		// 	手机号', rule: 'phone'
		// 	区间', rule: 'between:1,9'
		// 	电话, rule: 'tel'
		// 	车牌号码, rule: 'car'
		// 	身份证号, rule: 'sfz'
		// 	QQ, rule: 'qq'
		checking: rules => {
			if(!(rules instanceof Array)) {
				console.wran('表单验证参数出错')
				return false
			}
			for(let i = 0,max = rules.length; i < max; i++) {
				let thisVal = rules[i].value
				if(thisVal ===  undefined || !rules[i].rule) continue
				let thisName = rules[i].text
				// 必填
				let isRequire = rules[i].rule.indexOf('require') >= 0 ? true : false
				let isEmail = rules[i].rule.indexOf('email') >= 0 ? true : false
				let isPhone = rules[i].rule.indexOf('phone') >= 0 ? true : false
				let isTel = rules[i].rule.indexOf('tel') >= 0 ? true : false
				let isCar = rules[i].rule.indexOf('car') >= 0 ? true : false
				let isSfz = rules[i].rule.indexOf('sfz') >= 0 ? true : false
				let isQQ = rules[i].rule.indexOf('qq') >= 0 ? true : false
				// 中文+字长限制,例:chs:2,5
				let isChs = rules[i].rule.indexOf('chs:') >= 0 ? true : false
				let chsMatch = rules[i].rule.match(/chs:(\d+),(\d+)($|\|)/)
				// 只能是,例:只能是1或0(in:1,0)
				let isIn = rules[i].rule.indexOf('in:') >= 0 ? true : false
				let inMatch = rules[i].rule.match(/in:(.+)($|\|)/)
				let inArray = inMatch ? inMatch[1].split(',') : ''
				// 区间,例:只能在0-9(between:0,23)
				let isBetween = rules[i].rule.indexOf('between:') >= 0 ? true : false
				let betweenMatch = rules[i].rule.match(/between:(\w{1}),(\w{1})($|\|)/)
				let betweenReg = betweenMatch ? new RegExp('^['+ betweenMatch[1] +'-'+ betweenMatch[2] +']$') : ''
				if(thisVal == '') {
					if(isRequire) return `${thisName}不能为空`
				}else{
					// 邮箱
					if(isEmail && !(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(thisVal))) return thisName +'格式不正确'
					// 手机号
					if(isPhone && !(/^1\d{10}$/.test(thisVal))) return thisName +'不正确'
					// 电话
					if(isTel && !(/^(\d{7,8})(-(\d{3,}))?$/.test(thisVal))) return thisName +'不正确'
					// 车牌号码
					if(isCar && !(/^[0-9a-zA-Z]{5}$/.test(thisVal))) return thisName +'不正确'
					// 身份证号码
					if(isSfz){
						let Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]; // 加权因子
						let ValideCode = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]; // 身份证验证位值.10代表X
						function IdCardValidate(idCard) {
							if (idCard.length == 15) {
								return isValidityBrithBy15IdCard(idCard); //进行15位身份证的验证
							} else if (idCard.length == 18) {
								var a_idCard = idCard.split(""); // 得到身份证数组
								if (isValidityBrithBy18IdCard(idCard) && isTrueValidateCodeBy18IdCard(a_idCard)) { //进行18位身份证的基本验证和第18位的验证
									return true;
								} else {
									return false;
								}
							} else {
								return false;
							}
						}
						/**
						 * 判断身份证号码为18位时最后的验证位是否正确
						 * @param a_idCard 身份证号码数组
						 * @return
						 */
						function isTrueValidateCodeBy18IdCard(a_idCard) {
							var sum = 0; // 声明加权求和变量
							if (a_idCard[17].toLowerCase() == 'x') {
								a_idCard[17] = 10; // 将最后位为x的验证码替换为10方便后续操作
							}
							for (var i = 0; i < 17; i++) {
								sum += Wi[i] * a_idCard[i]; // 加权求和
							}
							let valCodePosition = sum % 11; // 得到验证码所位置
							if (a_idCard[17] == ValideCode[valCodePosition]) {
								return true;
							} else {
								return false;
							}
						}
						/**
						 * 验证18位数身份证号码中的生日是否是有效生日
						 * @param idCard 18位书身份证字符串
						 * @return
						 */
						function isValidityBrithBy18IdCard(idCard18) {
							var year = idCard18.substring(6, 10);
							var month = idCard18.substring(10, 12);
							var day = idCard18.substring(12, 14);
							var temp_date = new Date(year, parseFloat(month) - 1, parseFloat(day));
							// 这里用getFullYear()获取年份，避免千年虫问题
							if (temp_date.getFullYear() != parseFloat(year) ||
								temp_date.getMonth() != parseFloat(month) - 1 ||
								temp_date.getDate() != parseFloat(day)) {
								return false;
							} else {
								return true;
							}
						}
						/**
						* 验证15位数身份证号码中的生日是否是有效生日
						* @param idCard15 15位书身份证字符串
						* @return
						*/
						function isValidityBrithBy15IdCard(idCard15) {
							var year = idCard15.substring(6, 8);
							var month = idCard15.substring(8, 10);
							var day = idCard15.substring(10, 12);
							var temp_date = new Date(year, parseFloat(month) - 1, parseFloat(day));
							// 对于老身份证中的你年龄则不需考虑千年虫问题而使用getYear()方法
							if (temp_date.getYear() != parseFloat(year) ||
								temp_date.getMonth() != parseFloat(month) - 1 ||
								temp_date.getDate() != parseFloat(day)) {
								return false;
							} else {
								return true;
							}
						}
						if(!IdCardValidate(thisVal)) return thisName +'不正确'
					}
					// QQ
					if(isQQ && !(/[1-9]\d{4,10}/.test(thisVal))) return thisName +'不正确'
					// 中文长度
					if(isChs && !(/^[\u4e00-\u9fa5]+$/i.test(thisVal))) return thisName +'只能是汉字'
					if(isChs && chsMatch && thisVal.length < chsMatch[1]) return thisName +'长度不能小于'+ chsMatch[1]
					if(isChs && chsMatch && thisVal.length > chsMatch[2]) return thisName +'长度不能大于'+ chsMatch[2]
					// 限定参数
					if(isIn && inArray && inArray.indexOf(''+thisVal) < 0) return thisName +'必须在'+ inMatch[1] +'范围内'
					// 限定区间
					if(isBetween && betweenReg && !betweenReg.test(thisVal)) return thisName +'只能在' + betweenMatch[1] +','+ betweenMatch[2] + '区间'

				}
			}
		},
		// 星座查询
		getXz: (m, d) => {
			let xzList = [
				{
					divider: 20,
					lower: '摩羯',
					upper: '水瓶'
				},{
					divider: 19,
					lower: '水瓶',
					upper: '双鱼'
				},{
					divider: 21,
					lower: '双鱼',
					upper: '白羊'
				},{
					divider: 20,
					lower: '白羊',
					upper: '金牛'
				},{
					divider: 21,
					lower: '金牛',
					upper: '双子'
				},{
					divider: 22,
					lower: '双子',
					upper: '巨蟹'
				},{
					divider: 23,
					lower: '巨蟹',
					upper: '狮子'
				},{
					divider: 23,
					lower: '狮子',
					upper: '处女'
				},{
					divider: 23,
					lower: '处女',
					upper: '天秤'
				},{
					divider: 24,
					lower: '天秤',
					upper: '天蝎'
				},{
					divider: 23,
					lower: '天蝎',
					upper: '射手'
				},{
					divider: 22,
					lower: '射手',
					upper: '摩羯'
				}
			];
			if(d < xzList[m-1].divider) return xzList[m-1].lower
			else return xzList[m-1].upper
		}
	},
	// 右侧悬浮以及返回顶部
	goTop: () => {
		let sider = $('.J_sider')
		if(!sider.length) return
		let goTop = $('.J_go_top')
		// 初始化判断是否显示
		if($(window).scrollTop() > 500){
			sider.fadeIn('fast')
		}
		// 现象滚动显示
		$(window).scroll(() => {
			var scrollY = $(window).scrollTop();
			if (scrollY > 500) {
				sider.fadeIn('fast')
			} else {
				sider.fadeOut()
			};
		});
		// 点击回到头部
		goTop.on('click',function(){
			$('body,html').animate({ 'scrollTop': 0 }, 300);
		});
	},
	// 公共radio美化
	publicRadio: () => {
		var publicRadio = $('.J_radio');
		if(!publicRadio.length) return
		publicRadio.find('.J_radio_item').on('click', function() {
			if($(this).hasClass('active')) return
			$(this).addClass('active').siblings('.J_radio_item').removeClass('active');
			if($(this).siblings('input').length) $(this).siblings('input').val($(this).data('value'))
		});
	},
	// select美化
	publicSelect: () => {
		var publicSelect = $(".J_select");
		if(!publicSelect.length) return
		publicSelect.children('span').text(function() {
			if($(this).siblings('select').find("option:selected").val()) $(this).css('color', '#666');
			else $(this).css('color', '#999');
			return $(this).siblings('select').find("option:selected").text();
		});
		publicSelect.children('select').on('change', function(){
			var selTxt = $(this).find("option:selected").text();
			$(this).siblings('span').text(selTxt);
			if($(this).find("option:selected").val()) $(this).siblings('span').css('color', '#666');
			else $(this).siblings('span').css('color', '#999');
		})
	},
	// checkbox美化
	publicCheckbox: () => {
		let publicCheckbox = $('.J_checkbox')
		if(!publicCheckbox.length) return
		publicCheckbox.on('click', function(){
			if($(this).hasClass('active')){
				$(this).removeClass('active').find('input').val('off')
			}else{
				$(this).addClass('active').find('input').val('on')
			}
		})
	},
	// 公历农历日期选择月份与日期关系
	dateMonthDay: () => {
		// 调整公历每月天数
		if($('.J_date_c_picker').length){
			// 判断是不是闰年
			function changeYear(el,monthArray){
				var Year=el.find('.J_c_year').val();
				if ((!(Year % 4) && (Year % 100)) || !(Year % 400)) {
					monthArray[1]=29;
				} else {
					monthArray[1]=28;
				}
				el.find('.J_c_month').trigger('change');
			}
			// 重新渲染天数
			function resetDates(el,index,monthArray){
				if(isNaN(parseInt(index))) index = 0;
				// 获取目前选择的日期，如果改变的月份也有这一天就默认选它
				var day=el.find('.J_c_day').data('selected') || 1,option='';
				el.find('.J_c_day').html("");
				if(isNaN(parseInt(day))){
					el.find('.J_c_day').append(`<option value="" selected="selected" hidden="hidden">${day}</option>`);
				}
				for(var o=1;o<monthArray[index]+1;o++){
					if(o == day){
						option = '<option value="'+o+'" selected="selected">'+o+'日</option>'
					}else{
						option = '<option value="'+o+'">'+o+'日</option>'
					}
					el.find('.J_c_day').append(option);
				}
				el.find('.J_c_day').trigger('change');
			}
			function cDatePicker(el){
				var option= '';
				var year=el.find('.J_c_year').data('selected') || 2000;
				var yearStart=parseInt(el.find('.J_c_year').data('start')) || 1940;
				var yearEnd=parseInt(el.find('.J_c_year').data('end')) || 2030;
				var month=el.find('.J_c_month').data('selected') || 1;
				var monthArray=[31,29,31,30,31,30,31,31,30,31,30,31];
				// 渲染年份
				el.find('.J_c_year').html("");
				if(isNaN(parseInt(year))){
					el.find('.J_c_year').append(`<option value="" selected="selected" hidden="hidden">${year}</option>`);
				}
				for(var i=yearStart;i<yearEnd;i++){
					if(i == year){
						option = '<option value="'+i+'" selected="selected">'+i+'年</option>'
					}else{
						option = '<option value="'+i+'">'+i+'年</option>'
					}
					el.find('.J_c_year').append(option);
				}
				// 渲染月份
				el.find('.J_c_month').html("");
				if(isNaN(parseInt(month))){
					el.find('.J_c_month').append(`<option value="" selected="selected" hidden="hidden">${month}</option>`);
				}
				for(var o=1;o<13;o++){
					if(o == month){
						option = '<option value="'+o+'" selected="selected">'+o+'月</option>'
					}else{
						option = '<option value="'+o+'">'+o+'月</option>'
					}
					el.find('.J_c_month').append(option);
				}
				// 渲染时分
				el.find('.J_c_hour').html('<option value="" selected="selected" hidden="hidden">请选择</option>');
				el.find('.J_c_minute').html('<option value="" selected="selected" hidden="hidden">请选择</option>');
				var hourCn = [
					'子','丑','丑','寅','寅','卯','卯','辰','辰','巳','巳','午',
					'午','未','未','申','申','酉','酉','戌','戌','亥','亥','子'
				]
				for(var j=0;j<24;j++){
					el.find('.J_c_hour').append(`<option value="${j}">${j}时-${hourCn[j]}时</option>`);
				}
				for(var k=0;k<60;k++){
					el.find('.J_c_minute').append(`<option value="${k}">${k}分</option>`);
				}
				el.find('.J_c_hour').trigger('change');
				el.find('.J_c_minute').trigger('change');
				// 保存选择日期
				el.find('.J_c_day').change(function(){
					if($(this).data('selected') != $(this).find("option:selected").text()){
						$(this).data('selected',$(this).val());
					}
					// 合并年月日
					if(el.find('.J_c_picker_combined').length>0){
						var year = el.find('.J_c_year').val();
						var month = el.find('.J_c_month').val();
						var day = el.find('.J_c_day').val();
						if(year && month && day){
							el.find('.J_c_picker_combined').val(`${year}-${month}-${day}`)
						}
					}
				});
				// 触发日期渲染
				el.find('.J_c_month').change(function(){
					var index=parseInt($(this).val())-1;
					resetDates(el,index,monthArray);
				});
				el.find('.J_c_year').change(function(){changeYear(el,monthArray);});
				if(el.find('.J_c_year').length) el.find('.J_c_year').trigger('change');
				else el.find('.J_c_month').trigger('change');
			}
			for(var o=0;o<$('.J_date_c_picker').length;o++){
				cDatePicker($('.J_date_c_picker').eq(o))
			}
		};
		// 调整农历每月天数
		if($('.J_date_s_picker').length){
			// 判断有没有闰月
			function _changeYear(el,monthArray){
				var monthLength = el.find('.J_s_month').find('option').length,currentLeapMonth=0
				// 重新渲染钱删除已有的闰月
				if(monthLength!=12 && el.find('.J_s_month').data('run')){
					var lIndex = el.find('.J_s_month').data('run')
					el.find('.J_s_month').find('option')[lIndex].remove();
				}
				// 查询闰月年份
				currentLeapMonth = solarLunar.leapMonth(el.find('.J_s_year').val());
				// 如果有闰月则重新渲染
				if(currentLeapMonth!=0){
					el.find('.J_s_month').data('run',currentLeapMonth)
					el.find('.J_s_month').get(0).options.add(new Option("闰"+monthArray[currentLeapMonth-1],"r"+currentLeapMonth),currentLeapMonth);
				}
				el.find(".J_s_month").trigger('change');
			}
			// 重新渲染天数
			function _resetDates(el, index, dayArray){
				if(isNaN(parseInt(index))) index = 1;
				var leap = false, monthLength = 0;
				var year = el.find('.J_s_year').val();
				// 获取目前选择的日期，如果改变的月份也有这一天就默认选它
				var day=el.find('.J_s_day').data('selected') || 1,option='';
				// 判断是否是闰月
				if(/r/i.test(index)){
					leap = true
					index = index.slice(1)
				}else index = parseInt(index)
				// 获取本月天数
				if(leap) monthLength = solarLunar.leapDays(year)
				else monthLength = solarLunar.monthDays(year, index)
				// 渲染天数
				el.find('.J_s_day').html("");
				if(isNaN(parseInt(day))){
					el.find('.J_s_day').append(`<option value="" selected="selected" hidden="hidden">${day}</option>`);
				}
				for(var o=1;o<monthLength+1;o++){
					if(o == day){
						option = '<option value="'+o+'" selected="selected">'+dayArray[o-1]+'</option>'
					}else{
						option = '<option value="'+o+'">'+dayArray[o-1]+'</option>'
					}
					el.find('.J_s_day').append(option);
				}
				el.find('.J_s_day').trigger('change');
			}
			// 农历转公历
			function lunar2solar(el){
				var year = el.find('.J_s_year').val();
				var month = el.find('.J_s_month').val();
				var day = el.find('.J_s_day').val();
				var isLeap = false;
				if(/r/i.test(month)){
					isLeap = true;
					month = month.slice(1);
				}
				var solar = solarLunar.lunar2solar(parseInt(year), parseInt(month), parseInt(day),isLeap);
				if(el.find('.J_s_year').siblings('input').length>0){
					el.find('.J_s_year').siblings('input').val(solar.cYear)
				}
				if(el.find('.J_s_month').siblings('input').length>0){
					el.find('.J_s_month').siblings('input').val(solar.cMonth)
				}
				if(el.find('.J_s_day').siblings('input').length>0){
					el.find('.J_s_day').siblings('input').val(solar.cDay)
				}
			}
			function sDatePicker(el){
				var option= '';
				var year=el.find('.J_s_year').data('selected') || 2000;
				var yearStart=parseInt(el.find('.J_s_year').data('start')) || 1940;
				var yearEnd=parseInt(el.find('.J_s_year').data('end')) || 2030;
				var month=el.find('.J_s_month').data('selected') || 1;
				var monthArray=["一","二","三","四","五","六","七","八","九","十","十一","十二"];
				var dayArray=["初一","初二","初三","初四","初五","初六","初七","初八","初九","初十","十一","十二","十三","十四","十五","十六","十七","十八","十九","二十","廿一","廿二","廿三","廿四","廿五","廿六","廿七","廿八","廿九","三十"];
				// 渲染年份
				el.find('.J_s_year').html("");
				if(isNaN(parseInt(year))){
					el.find('.J_s_year').append(`<option value="" selected="selected" hidden="hidden">${year}</option>`);
				}
				for(var i=yearStart;i<yearEnd;i++){
					if(i == year){
						option = '<option value="'+i+'" selected="selected">'+i+'年</option>'
					}else{
						option = '<option value="'+i+'">'+i+'年</option>'
					}
					el.find('.J_s_year').append(option);
				}
				// 渲染月份
				el.find('.J_s_month').html("");
				if(isNaN(parseInt(month))){
					el.find('.J_s_month').append(`<option value="" selected="selected" hidden="hidden">${month}</option>`);
				}
				for(var o=1;o<13;o++){
					if(o == month){
						option = '<option value="'+o+'" selected="selected">'+monthArray[o-1]+'月</option>'
					}else{
						option = '<option value="'+o+'">'+monthArray[o-1]+'月</option>'
					}
					el.find('.J_s_month').append(option);
				}
				// 渲染时分
				el.find('.J_s_hour').html('<option value="" selected="selected" hidden="hidden">请选择</option>');
				el.find('.J_s_minute').html('<option value="" selected="selected" hidden="hidden">请选择</option>');
				var hourCn = [
					'子','丑','丑','寅','寅','卯','卯','辰','辰','巳','巳','午',
					'午','未','未','申','申','酉','酉','戌','戌','亥','亥','子'
				]
				for(var j=0;j<24;j++){
					el.find('.J_s_hour').append(`<option value="${j}">${j}时-${hourCn[j]}时</option>`);
				}
				for(var k=0;k<60;k++){
					el.find('.J_s_minute').append(`<option value="${k}">${k}分</option>`);
				}
				el.find('.J_s_hour').trigger('change');
				el.find('.J_s_minute').trigger('change');
				// 保存选择日期
				el.find('.J_s_day').change(function(){
					if($(this).data('selected') != $(this).find("option:selected").text()){
						$(this).data('selected',$(this).val());
					}
					var year = el.find('.J_s_year').val();
					var month = el.find('.J_s_month').val();
					var day = el.find('.J_s_day').val();
					if(year && month && day){
						lunar2solar(el);
						// 合并年月日
						if(el.find('.J_s_picker_combined').length>0){
							el.find('.J_s_picker_combined').val(`${year}-${month}-${day}`)
						}
					}
				});
				// 触发日期渲染
				el.find('.J_s_month').change(function(){
					var index=$(this).val();
					_resetDates(el, index, dayArray);
				});
				el.find('.J_s_year').change(function(){_changeYear(el,monthArray);});
				el.find('.J_s_year').trigger('change');
			}
			for(var o=0;o<$('.J_date_s_picker').length;o++){
				sDatePicker($('.J_date_s_picker').eq(o))
			}
		}
	},
	// 地址选择
	addrPicker: () => {
		let addrPicker = $('.J_addr_picker');
		if(!addrPicker.length) return;
		let addressList =  require('site-linkage');
		// 渲染城市
		let changeProvince = el => {
			if(el.find('.J_city').length){
				let city=el.find('.J_city').data('selected'),option;
				el.find('.J_city').html('');
				if(!city){
					el.find('.J_city').append('<option value="" selected="selected" hidden="hidden">请选择</option>');
				}
				let selectProvince = el.find('.J_province').find("option:selected").val();
				if(selectProvince){
					addressList.getProvince(selectProvince).data.forEach(item => {
						if(item == city){
							option = `<option value="${item}" selected="selected">${item}</option>`
						}else{
							option = `<option value="${item}">${item}</option>`
						}
						el.find('.J_city').append(option);
					});
				}
			}
			el.find('.J_city').data('selected', '').trigger('change');
		}
		// 渲染地区
		let changeCity = el => {
			if(el.find('.J_area').length){
				let area=el.find('.J_area').data('selected'),option;
				el.find('.J_area').html('');
				if(!area){
					el.find('.J_area').append('<option value="" selected="selected" hidden="hidden">请选择</option>');
				}
				let selectProvince = el.find('.J_province').find("option:selected").val();
				let selectCity = el.find('.J_city').find("option:selected").val();
				if(selectCity){
					addressList.getProvince(selectProvince).getCity(selectCity).data.forEach(item => {
						if(item == area){
							option = `<option value="${item}" selected="selected">${item}</option>`
						}else{
							option = `<option value="${item}">${item}</option>`
						}
						el.find('.J_area').append(option);
					});
				}
			}
			el.find('.J_area').data('selected', '').trigger('change');
		}
		let provincePicker = el => {
			let province=el.find('.J_province').data('selected'),option;
			// 渲染省份
			el.find('.J_province').html("");
			if(!province){
				el.find('.J_province').append('<option value="" selected="selected" hidden="hidden">请选择</option>');
			}
			addressList.provinceList.forEach(item => {
				if(item == province){
					option = `<option value="${item}" selected="selected">${item}</option>`
				}else{
					option = `<option value="${item}">${item}</option>`
				}
				el.find('.J_province').append(option);
			});
			el.find('.J_city').change(function(){changeCity(el);});
			el.find('.J_province').change(function(){changeProvince(el);});
			el.find('.J_province').trigger('change');
		}
		for(var o=0;o<addrPicker.length;o++){
			provincePicker(addrPicker.eq(o))
		}
	},
	// 右侧栏日历数据
	sideCalendar: () => {
		let sideCalendar = $('.J_side_calendar')
		if(!sideCalendar.length) return
		let _today = sideCalendar.data('date')
		let today = new Date(_today).getTime()
		const lunarDate = solarLunar.solar2lunar(_today.split('/')[0], _today.split('/')[1], _today.split('/')[2])
		$.getJSON("/rili/huangli.html?y="+_today.split('/')[0]+"&m="+_today.split('/')[1]+"&d="+_today.split('/')[2]+"&type=json",function(data){
			let yi = [], ji = [];
			if(data !== "" && data !== undefined){
				yi = data.yi.split(' ')
				ji = data.ji.split(' ')
			}
			sideCalendar.html(`<div class="side-calendar__date">
				<div class="side-calendar__date--card">
					<div class="date">${app.tool.formatTime(today, 'Y')}年${app.tool.formatTime(today, 'M')}月</div>
					<div class="day">${app.tool.formatTime(today, 'D')}<span>${lunarDate.term}</span></div>
				</div>
				<div>农历 ${lunarDate.monthCn}${lunarDate.dayCn}<br />${lunarDate.gzYear}年【${lunarDate.animal}年】<br />${lunarDate.gzMonth}月 ${lunarDate.gzDay}日</div>
			</div>
			<div class="side-calendar__yiji">
				<span class="yi">宜</span>
				${(function(yi){
					let html = '';
					for(let o=0;o<yi.length;o++){
						html += `<a href="/hdjr.html" class="red">${yi[o]}</a>`
					}
					return html
				})(yi)}
			</div>
			<div class="side-calendar__yiji">
				<span class="ji">忌</span>
				${(function(ji){
					let html = '';
					for(let o=0;o<ji.length;o++){
						html += `<a href="/hdjr.html">${ji[o]}</a>`
					}
					return html
				})(ji)}
			</div>`)
		})
	},
	// 免费算命提交验证表单
	formTool: () => {
		let formTool = $('.J_form_tool')
		if(!formTool.length) return
		formTool.find('.J_form_tool_submit').on('click', function(){
			let thisForm = $(this).parents('.J_form_tool')
			let rules = thisForm.serializeArray(), el;
			for(let o=0;o<rules.length;o++){
				el = thisForm.find(`input[name=${rules[o].name}]`).length ? thisForm.find(`input[name=${rules[o].name}]`) : thisForm.find(`select[name=${rules[o].name}]`)
				rules[o].text = el.data('text') || rules[o].name
				rules[o].rule = el.data('rule')
			}
			let error = app.tool.checking(rules)
			if(error){
				app.tool.msg(error)
				return
			}else{
				thisForm.get(0).submit()
				thisForm.get(0).reset()
			}
		})
	},
	// 生肖查询
	shengxiao: () => {
		let shengxiao = $('.J_shengxiao_form')
		if(!shengxiao.length) return
		shengxiao.find('.J_shengxiao_chaxun').on('click', function(){
			let checkYear, formData = $(this).parents('.J_shengxiao_form').serializeArray();
			for(let o=0;o<formData.length;o++){
				if(formData[o].name == 'year') checkYear = formData[o].value
			}
			if(checkYear){
				let lunarData = solarLunar.lunar2solar(parseInt(checkYear), 1, 1)
				let sxList = {
					"鼠": "1", "牛": "2", "虎": "3", "兔": "4",
					"龙": "5", "蛇": "6", "马": "7", "羊": "8",
					"猴": "9", "鸡": "10", "狗": "11", "猪": "12"
				}
				let sx = sxList[lunarData.animal];
				window.location.href = `/sxxg/${sx}.html`
			}
		})
	},
	// 星座查询
	xingzuo: () => {
		let xingzuo = $('.J_xingzuo_form')
		if(!xingzuo.length) return
		xingzuo.find('.J_xingzuo_chaxun').on('click', function(){
			let checkMonth, checkDay, formData = $(this).parents('.J_xingzuo_form').serializeArray();
			for(let o=0;o<formData.length;o++){
				if(formData[o].name == 'month') checkMonth = formData[o].value
				else if(formData[o].name == 'day') checkDay = formData[o].value
			}
			if(checkMonth && checkDay){
				let xzList = {
					"白羊": "1", "金牛": "2", "双子": "3", "巨蟹": "4",
					"狮子": "5", "处女": "6", "天秤": "7", "天蝎": "8",
					"射手": "9", "摩羯": "10", "水瓶": "11", "双鱼": "12"
				}
				let xz = xzList[app.tool.getXz(checkMonth, checkDay)];
				window.location.href = `/xingzuo_${xz}.html`
			}
		})
	},
	// 个人隐私协议显示隐藏
	protocolTap: function(){
		var protocolBox = $('.J_protocol_pop');
		if(!protocolBox.length) return;
		var tabTitle = protocolBox.find('.J_protocol_tab').children('li');
		var tabText = protocolBox.find('.J_protocol_content').children('li');
		$('.J_protocolShowBtn').on('click',function(){
			protocolBox.fadeIn('fast');
			app.tool.setPopup();
		})
		protocolBox.find('.J_protocol_close').on('click',function(){
			app.tool.unsetPopup();
			protocolBox.hide();
		})
		tabTitle.on('click', function(){
			$(this).addClass('active').siblings().removeClass('active');
			tabText.eq($(this).index()).addClass('active').siblings().removeClass('active');
		})
	},
	// 在线测试表单提交
	appSubmit: function(){
		let appForm = $('.J_form_app')
		if(!appForm.length) return;
		var formLock = false;
		appForm.find('.J_form_app_submit').on('click', function (e) {
			e.preventDefault();
			if(formLock) return false;
			let thisForm = $(this).parents('.J_form_app');
			// 判读表单是否有同意协议，协议是否勾选
			var inputPrivacyProtocol = thisForm.find('input[name="privacy_protocol"]');
			if(inputPrivacyProtocol.val() == 'off'){
				app.tool.msg('您未同意个人隐私协议');
				formLock = false
				return false;
			};
			$.ajax({
				type: "POST",
				url: thisForm.attr('action'),
				data: thisForm.serialize(),
				dataType: 'json',
				beforeSend: function(){
					// 锁定再次提交请求
					formLock = true;
					app.tool.loading('');
				},
				success:function(res){
					if (res.code) {
						app.tool.msg(res.msg, 1000)
						var argu = [], _arguments = '';
						var theme = thisForm.data('theme');
						var spread = thisForm.data('spread');
						if(theme) argu.push({name: 'theme',value: theme})
						if(spread)  argu.push({name: 'spread',value: spread})
						if(argu.length>0){
							_arguments += '?';
							for(var o=0;o<argu.length;o++){
								_arguments += `${argu[o].name}=${argu[o].value}`;
								if(o<argu.length-1) _arguments += '&';
							}
						}
						//刷新当前页
						if(res.url) window.location.href = `https://ffsm.bazi5.com${res.url}${_arguments}`
					}else app.tool.msg(res.msg, 1000)
					app.tool.closeLoading()
					setTimeout(function(){formLock = false;}, 800)
				}
			});
		});
	},
	// 上报点击数
	uploadHits() {
		var hitsObj = $('#hitsArticle');
		if (!hitsObj.length) return false;
		var id = hitsObj.data('id') || '0';
		var type = hitsObj.data('type') || '0';
		$.ajax({ 
			type: "get", 
			url: "/bazi/v1/content/hits.html", 
			data: { 
				id: id, 
				type: type,
				timer: Math.round(new Date().getTime() / 1000)
			}, 
			dataType: 'json'
		})
	}
}
$(function() {
	//遍历执行app中的方法
	for (let key in app) {
		typeof app[key] == 'function' && app[key]();
	}
})
